import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';

import { RangeState } from '../calendar';
import { Range } from '../calendar/calendar-api';

class DateFieldAPI extends ComponentAPI implements Changeable<string | string[] | undefined> {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<string | string[] | undefined>();

  getApplyExpression(): string {
    return this.state.applyExpression;
  }

  setApplyExpression(applyExpression: string): void {
    this.setState({ applyExpression });
  }

  getClearExpression(): string {
    return this.state.clearExpression;
  }

  setClearExpression(clearExpression: string): void {
    this.setState({ clearExpression });
  }

  getTodayExpression(): string {
    return this.state.todayExpression;
  }

  setTodayExpression(todayExpression: string): void {
    this.setState({ todayExpression: todayExpression });
  }

  getNoAppointmentsExpression(): string {
    return this.state.noAppointmentsExpression;
  }

  setNoAppointmentsExpression(noAppointmentsExpression: string): void {
    this.setState({ noAppointmentsExp: noAppointmentsExpression });
  }

  getInitialDate(): string {
    return this.state.initialDate;
  }

  setInitialDate(initialDate: string): void {
    this.setState({ initialDate });
  }

  getInterval(): boolean {
    return this.state.interval;
  }

  setInterval(interval: boolean): void {
    this.setState({ interval });
  }

  isShowEvents(): boolean {
    return this.state.showEvents;
  }

  setShowEvents(showEvents: boolean): void {
    this.setState({ showEvents });
  }

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  isOpenInCurrentDate(): boolean {
    return this.state.openInCurrentDate;
  }

  setOpenInCurrentDate(openInCurrentDate: boolean): void {
    this.setState({ openInCurrentDate });
  }

  getRanges(): Range[] {
    return [...(this.state.ranges || [])];
  }

  setRanges(ranges: Range[]): void {
    this.setState({ ranges });
  }

  addRange(startDate: string, endDate: string): void {
    const ranges = this.getRanges();
    ranges.push({ startDate, endDate });
    this.setRanges(ranges);
  }

  addRanges(ranges: Range[]): void {
    const oldRanges = this.getRanges();
    this.setRanges(oldRanges.concat(ranges));
  }

  clearRanges(): void {
    this.setRanges([]);
  }

  setRangeState(rangeState: RangeState): void {
    this.setState({ rangeState });
  }

  getRangeState(): RangeState {
    return this.state.rangeState;
  }
}

export default DateFieldAPI;
